// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__S9EbY","sidebar--mobile":"Sidebar_sidebar--mobile__V43Ov"};